import React from "react";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import Select from "react-select";
import useCancelVerificationModal from "./useCancelVerifcationModal";

function CancelVerificationModal({
  handleClose,
  refetch,
  selectedItem,
  dispatch,
  updateConfig,
  approvedState,
  selectionRef,
  selectionRef2,
  // detailrefetch,
}) {
  const { formik, statusOptions } = useCancelVerificationModal({
    handleClose,
    refetch,
    selectedItem,
    dispatch,
    updateConfig,
    approvedState,
    selectionRef,
    selectionRef2,
    // detailrefetch,
  });
  return (
    <>
      <div className="input-wrap pro-mb-4">
        <div className="pro-d-flex pro-flex-col pro-mb-3 pro-w-100">
          <div className="input-wrap">
            <label
              htmlFor="status"
              className="pro-font-sm pro-mb-1 pro-fw-medium"
            >
              Status
            </label>

            <Select
              id="status"
              name="status"
              options={statusOptions}
              value={statusOptions.find(
                (option) => option.value === formik.values.status,
              )}
              onChange={(option) =>
                formik.setFieldValue("status", option?.value)
              }
              onBlur={formik.handleBlur}
              placeholder={"Select"}
              className={`pro-input  lg ${formik.errors.status && formik.touched.status && "error"}`}
              classNamePrefix="pro-input"
            />
            {formik.touched.status && formik.errors.status && (
              <span className="error-text">{formik.errors.status}</span>
            )}
          </div>
        </div>
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Provide the reason for your action
        </label>
        <div className="input-wrap">
          <textarea
            id="cancelreason"
            rows={4}
            name="cancelreason"
            className={`pro-input lg ${
              formik.errors.cancelreason &&
              formik.touched.cancelreason &&
              " error"
            }`}
            onChange={(e) =>
              formik.setFieldValue("cancelreason", e.target.value)
            }
            onBlur={formik.handleBlur}
            value={formik.values.cancelreason}
          ></textarea>
          {formik.touched.cancelreason && formik.errors.cancelreason && (
            <span className="error-text">{formik.errors.cancelreason}</span>
          )}
        </div>

        <div
          className={`col-12 pro-pt-5 pro-d-flex pro-justify-end  offcanvas-footer-sticky-btn `}
        >
          <Button className={"pro-btn-link lg pro-px-5"} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className={"pro-btn-primary lg pro-ms-3"}
            type="submit"
            onClick={formik.handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </>
  );
}

export default CancelVerificationModal;
